import { useState } from 'react';
import axios from 'axios';

interface DayEntryData {
  description: string;
  hours: number;
}

export const useUpdateDayEntry = () => {
  const [dayEntry, setDayEntry] = useState();
  const [loadingDayEntry, setLoadingDayEntry] = useState<boolean>();

  const updateDayEntry = async (
    dayEntryData: DayEntryData,
    timeTrackingId: string,
    assignmentId: string
  ) => {
    if (loadingDayEntry) return;
    try {
      setLoadingDayEntry(true);
      const { data } = await axios.post(`api/timetracking-day-entries/update`, {
        new_description: dayEntryData.description,
        new_axstimetrackingdayentryid: timeTrackingId,
        assignment: {
          new_axsassignmentid: assignmentId,
        },
        new_actualhours: dayEntryData.hours,
      });
      data && setDayEntry(data);
    } catch (err) {
      console.error(err);
    } finally {
      setLoadingDayEntry(false);
    }
  };

  return { dayEntry, loadingDayEntry, updateDayEntry };
};
